import React from 'react';
// pages
import Home from './pages/Home';
import Games from './pages/Games';
import VRGamesPages from './pages/VRGamesPages';
import Art from './pages/Artpage';
import NotFoundPage from './pages/NotFound';
// import ProjectTimeLog from './pages/ProjectTimeLog';
import NavBar from './components/NavBar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// dotEnv.config();

function App() {
  // document.addEventListener('contextmenu', event => event.preventDefault());
  // document.addEventListener('selectstart', event => event.preventDefault());
  return (
    <>
      <Router>
        <NavBar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/games' element={<Games />} />
          <Route path='/vrgames' element={<VRGamesPages />} />
          <Route path='/art' element={<Art />} />
          {/* <Route path='/project-timelog' element={<ProjectTimeLog />} /> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
